import classNames from "shared/utils/classNames";
import { ReactComponent as IconResetChatIframe } from "assets/images/icons/reset-chat-iframe.svg";

import { Props } from "./types";

function ButtonResetChatIframe(props: Props) {
  const { botInfo, resetChat, setIsResetChatModalOpen, className } = props;

  return (
    <div
      className={classNames("cursor-pointer", className)}
      onClick={() => {
        if (!botInfo.bot_info_config.show_post_chat_feedback) {
          return resetChat();
        }
        setIsResetChatModalOpen && setIsResetChatModalOpen(true);
      }}
    >
      <IconResetChatIframe />
    </div>
  );
}

export default ButtonResetChatIframe;
